import React from "react";
import { ItemGroupSummary, PurchaseHistory, PickUpPage } from '../component';
import GenerateOrderSummaryItems from "../common/GenerateOrderSummaryItems";
import { AboveTheFoldMarker, CriticalFeatureMarker, FunctionalMarker } from "../csa/markers";
import { parseBoldMarkers } from "../pickup/LabelUtils";
import { PickupInstructionsBreadCrumb } from "../common/BreadCrumb";

interface MissedPickupPageProps {
    itemGroupSummary: ItemGroupSummary;
    purchaseHistory: PurchaseHistory;
    pickupPage: PickUpPage;
}

/**
 * Missed-Pickup page component
 * Displays information about an order that wasn't picked up on time and was canceled
 */
const MissedPickupPage: React.FC<MissedPickupPageProps> = (props) => {
    return (
        <>
            <pui-stack spacingBottom="small">
                <PickupInstructionsBreadCrumb 
                    yourOrders={props.purchaseHistory.labels.yourOrders} 
                    pickUpInstructionsLabel={props.pickupPage.labels.kioskPickUpInstructionsLabel}
                />
            </pui-stack>
            <pui-stack id="missed-pickup-page"
                data-csa-c-content-id="missed-pickup-page"
                data-csa-c-type="card"
                data-csa-c-slot-id="missed-pickup">
                <pui-heading input={props.pickupPage.labels.missedPickUpMsg} headingLevel="1" textSize="large"
                    spacingBottom="medium" />
                <pui-text input={parseBoldMarkers(props.pickupPage.instructions.missedPickUpDetails)} spacingBottom="medium" />

                <pui-text input={props.pickupPage.labels.missedPickUpRetry} spacingBottom="medium" />

                <AboveTheFoldMarker />
                <CriticalFeatureMarker />
            </pui-stack>

            <pui-heading input={props.pickupPage.labels.orderSummary} headingLevel="2" textSize="medium"
                spacingBottom="small" />
            <GenerateOrderSummaryItems
                itemGroupSummary={props.itemGroupSummary}
            />
            <pui-divider spacingTop="mini" />

            <FunctionalMarker />
        </>
    );
};

export default MissedPickupPage;
